/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The SigfoxDeviceValueEvaluation model module.
* @module model/SigfoxDeviceValueEvaluation
* @version 2020-12-7
*/
export default class SigfoxDeviceValueEvaluation {
    /**
    * Constructs a new <code>SigfoxDeviceValueEvaluation</code>.
    * @alias module:model/SigfoxDeviceValueEvaluation
    * @class
    * @param ok {Boolean} 
    * @param value {Number} 
    */

    constructor(ok, value) {
        
        
        this['ok'] = ok;
        this['value'] = value;
        
    }

    /**
    * Constructs a <code>SigfoxDeviceValueEvaluation</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/SigfoxDeviceValueEvaluation} obj Optional instance to populate.
    * @return {module:model/SigfoxDeviceValueEvaluation} The populated <code>SigfoxDeviceValueEvaluation</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SigfoxDeviceValueEvaluation();
                        
            
            if (data.hasOwnProperty('ok')) {
                obj['ok'] = ApiClient.convertToType(data['ok'], 'Boolean');
            }
            if (data.hasOwnProperty('value')) {
                obj['value'] = ApiClient.convertToType(data['value'], 'Number');
            }
            if (data.hasOwnProperty('max')) {
                obj['max'] = ApiClient.convertToType(data['max'], 'Number');
            }
            if (data.hasOwnProperty('min')) {
                obj['min'] = ApiClient.convertToType(data['min'], 'Number');
            }
        }
        return obj;
    }

    /**
    * @member {Boolean} ok
    */
    'ok' = undefined;
    /**
    * @member {Number} value
    */
    'value' = undefined;
    /**
    * @member {Number} max
    */
    'max' = undefined;
    /**
    * @member {Number} min
    */
    'min' = undefined;




}
